<template>
  <b-card >
    <app-echart-stacked-area
      :option-data="option"
    />
  </b-card>
</template>

<script>
import { mapGetters } from 'vuex'
import AppEchartStackedArea from '@core/components/charts/echart/AppEchartStackedArea.vue'

export default {
  name: 'HomeChart',
  components: { AppEchartStackedArea },
  computed: {
    ...mapGetters('home', ['_orderOnemonth']),
    option() {
      // eslint-disable-next-line no-underscore-dangle
      const orderData = this._orderOnemonth

      // Eğer data property varsa (API response tamamı geliyorsa)
      if (orderData && orderData.data) {
        const result = {
          xAxisData: orderData.data.xAxisData || [],
          series: orderData.data.series || [],
        }
        return result
      }

      // Eğer direkt data objesi geliyorsa
      if (orderData && orderData.xAxisData) {
        const result = {
          xAxisData: orderData.xAxisData || [],
          series: orderData.series || [],
        }
        return result
      }

      return {
        xAxisData: [],
        series: [],
      }
    },
  },
  created() {
    this.$store.dispatch('home/getOrderOnemonth')
  },
}
</script>
